import React from 'react'
import { motion } from 'framer-motion'
import { FaRegBuilding, FaBed, FaUsers } from 'react-icons/fa'

const stats = [
  { icon: FaRegBuilding, value: '10', label: 'Premium Properties', suffix: '' },
  { icon: FaBed, value: '60', label: 'Available Beds', suffix: '' },
  { icon: FaUsers, value: '2000', label: 'Happy Residents', suffix: '+' },
]

const StatsBanner = () => {
  return (
    <section className="pb-16 bg-white">
      <div className="container-custom">
        <div
          className="rounded-3xl p-8 md:p-10 shadow-glow-lg overflow-hidden relative"
          style={{ background: 'linear-gradient(135deg, #9B2D8E 0%, #C030BC 55%, #e8228e 100%)' }}
        >
          {/* decorative circles */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full translate-x-1/3 -translate-y-1/3 blur-2xl pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -translate-x-1/3 translate-y-1/3 blur-2xl pointer-events-none" />

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-8 divide-y md:divide-y-0 md:divide-x divide-white/20">
            {stats.map(({ icon: Icon, value, label, suffix }, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.12 }}
                viewport={{ once: true }}
                className="flex items-center justify-center gap-5 pt-6 md:pt-0"
              >
                <div className="bg-white/15 backdrop-blur-sm p-4 rounded-2xl border border-white/20">
                  <Icon className="text-3xl text-white" />
                </div>
                <div>
                  <div className="text-3xl md:text-4xl font-heading font-extrabold text-white tracking-tight">
                    {value}{suffix}
                  </div>
                  <div className="text-sm text-white/70 font-medium mt-0.5">{label}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default StatsBanner
